import { shopPrefix } from '../../config';
import { BannerOut } from '../../store/api';
import { AgeCategory } from '../../../models/AgeCategory';
import { BannerCategory } from '../../../models/Banners';
import { LoanFormat } from '../../../models/LoanFormat';
import { http } from '../axios';

export const FETCH_BANNERS_URL = `${shopPrefix}/v2/banners/categoryPage/:categoryPage`;

export type FetchBannersResponse = ReadonlyArray<BannerOut>;
export type FetchBannersOpts = {
    readonly loanFormat?: LoanFormat;
    readonly ageCategory?: AgeCategory;
    readonly categoryKey?: string;
    readonly shopLanguage?: string;
};

export const fetchBanners = (
    categoryPage: BannerCategory,
    { loanFormat, ageCategory, categoryKey, shopLanguage }: FetchBannersOpts = {}
): Promise<FetchBannersResponse> => {
    return http
        .get<ReadonlyArray<BannerOut>>(FETCH_BANNERS_URL, {
            pathParams: { categoryPage },
            params: {
                loanFormat: loanFormat ? loanFormat.toUpperCase() : undefined,
                ageCategory,
                categoryKey,
                shopLanguage
            }
        })
        .then(response => response.data);
};
